var tabs = {
  TAB1: 'agent_search',
  TAB2: 'realtor_directory'
};
export default tabs;